module.exports = __webpack_public_path__ + "img/03.eea9d8f5.png";